<form *ngIf="configForm" [formGroup]="configForm" (ngSubmit)="onSubmit(configForm)">
  <mat-card class="content-card">
    <mat-card-header>
      <mat-card-title>
        <h5>Debtor service config</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-slide-toggle formControlName="debtorSendingEnabled">
        Debtor sending enabled
      </mat-slide-toggle>
      <mat-form-field>
        <input matInput placeholder="Max debtors per request" formControlName="maxDebtorsPerRequest">
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Individals - Send debtors after days" formControlName="sendAfterDays">
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Cancellations - Send debtors after days" formControlName="sendAfterDaysCancellations">
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Annual Fees - Send debtors after days" formControlName="sendAfterDaysAnnualfees">
      </mat-form-field>
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-button type="submit" [disabled]="!configForm.valid || configForm.pristine">
        <mat-icon>done</mat-icon>
        <a>Save</a>
      </button>
    </mat-card-actions>
  </mat-card>
</form>
